module.exports = __webpack_public_path__ + "static/img/3.ce361353.jpg";